// #311 L6 — who sees the Live button: a G100 (ingestion_type 'mqtt') the user owns, or any G100 for a superuser
// (owner decision 2026-10-12), the server's _can_control rule: is_owner comes from the API. The API is the gate; this only hides what it would refuse. The dashboard's
// Camera type predates G100 cameras ('http' | 'ftp'), hence a plain string here.
export function isG100(camera: { ingestion_type?: string }): boolean {
  return camera.ingestion_type === 'mqtt'
}

export function canWatchLive(
  camera: { ingestion_type?: string; is_owner?: boolean },
  me: { id: number; is_superuser: boolean } | null | undefined,
): boolean {
  if (!me || !isG100(camera)) return false
  return me.is_superuser || camera.is_owner === true
}
